import { AgingPeriodEnum } from 'src/app/revenue/shared/invoice/aging-period.model';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { LocalStorageService, TranslationService } from '../../shared/index';

import { RevenueService } from '../../revenue/shared/revenue.service';
import { AgingSummaryRow } from '../../revenue/shared/aging-summary.model';
import { ChartService } from '../../shared/chart/chart.service';
import { ChartData } from '../../shared/chart/chart-data.model';
import { UIChart } from 'primeng/chart';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { InvoiceAdvancedSearch } from 'src/app/revenue/shared/invoice/invoice-advanced-search.model';
import { RevenueItemService } from 'src/app/revenue/shared/revenue-items/revenue-item.service';

@Component({
  selector: 'wl-dashboard-neo-revenue-non-dues-aging',
  templateUrl: 'dashboard-neo-non-dues-aging.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [RevenueService, ChartService],
  styleUrls: ['dashboard-neo-non-dues-aging.component.less'],
    standalone: false
})
export class DashboardNeoNonDuesAgingComponent implements OnInit {
  public agingSummary: Array<AgingSummaryRow>;
  public agingTotals: AgingSummaryRow;
  public isLoading: boolean;

  public chartData: ChartData;
  public chartOptions: any;
  public colors: string[];

  @ViewChild('agingChart') agingChart: UIChart;

  public constructor(
    private _translationService: TranslationService,
    private _revenueService: RevenueService,
    private _chartService: ChartService,
    private _navigationService: NavigationService,
    private _localStorageService: LocalStorageService,
    private _revenueItemService: RevenueItemService
  ) {
    this.isLoading = true;

    this.chartData = new ChartData();
    this.chartOptions = {
      responsive: false,
      onClick: (e, el, c) => {
        const label = this.chartData.labels[el[0].index];
        const invoiceSearchParams = {} as InvoiceAdvancedSearch;

        switch (label.toLowerCase()) {
          case 'current':
            invoiceSearchParams.AgingPeriod = AgingPeriodEnum.AllPastDue;
            break;
          case '31 to 60':
            invoiceSearchParams.AgingPeriod = AgingPeriodEnum.DaysPastDue30;
            break;
          case '61 to 90':
            invoiceSearchParams.AgingPeriod = AgingPeriodEnum.DaysPastDue60;
            break;
          case '91 to 120':
            invoiceSearchParams.AgingPeriod = AgingPeriodEnum.DaysPastDue90;
            break;
          case '121+':
            invoiceSearchParams.AgingPeriod = AgingPeriodEnum.DaysPastDue120AndMore;
            break;
        }

        this._revenueItemService.getAllRevenueItems().then((data) => {
          invoiceSearchParams.RevenueItemNums = data.filter((x) => !x.DuesType).map((x) => x.ItemNum);
          this._localStorageService.setObject('InvoiceSelectorSearchParamsCache', invoiceSearchParams);
          this._navigationService.navigateToInvoiceFinder();
        });
      },
      plugins: {
        legend: {
          position: false,
        },
      },
      scales: {
        y: {
          ticks: {
            callback: (label, index, labels) => {
              return '$' + label;
            },
          },
        },
      },
    };
  }

  ngOnInit() {
    this.agingSummary = new Array<AgingSummaryRow>();
    this.agingTotals = new AgingSummaryRow();

    this._revenueService.getNonDuesAgingSummary().then((data: Array<AgingSummaryRow>) => {
      for (var i = 0; i < 5; i++) {
        switch (i) {
          case 0: {
            this.chartData.labels.push(this._translationService.getInstant('dashboard.revenue.aging.current'));
            break;
          }
          case 1: {
            this.chartData.labels.push(this._translationService.getInstant('dashboard.revenue.aging.31-to-60'));
            break;
          }
          case 2: {
            this.chartData.labels.push(this._translationService.getInstant('dashboard.revenue.aging.61-to-90'));
            break;
          }
          case 3: {
            this.chartData.labels.push(this._translationService.getInstant('dashboard.revenue.aging.91-to-120'));
            break;
          }
          case 4: {
            this.chartData.labels.push(this._translationService.getInstant('dashboard.revenue.aging.121Plus'));
            break;
          }
        }
        this.chartData.datasets[0].data.push(data[i].AmountDue);
      }
      this.agingTotals = data.splice(5, 1)[0];

      this.colors = this._chartService.getChartColors(data.length);
      this.chartData.datasets[0].backgroundColor = this.colors;

      this.agingChart.refresh();

      this.isLoading = false;
    });
  }
}
